import { init } from '@sentry/browser';
import AppSettingsProvider from '%app/js/common/services/AppSettingsProvider';
import isPageLoadFailure, { isPageLoadFailureMessage } from '%app/js/common/services/isPageLoadFailure';

const PAGE_LOAD_FAILURE_FINGERPRINT = ['page-load-failure'];
const FAILURE_KIND_TAG = 'failure_kind';
const LOADING_FAILURE_KIND = 'loading';

function markAsPageLoadFailure(event) {
    return {
        ...event,
        fingerprint: PAGE_LOAD_FAILURE_FINGERPRINT,
        tags: { ...event.tags, [FAILURE_KIND_TAG]: LOADING_FAILURE_KIND },
    };
}

const configureSentry = (config = {}) => {
    init({
        dsn: (new AppSettingsProvider()).getAppSettings().getSentryJsDsn(),
        beforeSend(event, hint) {
            if (hint && hint.originalException) {
                const { originalException: { mute, response } } = hint;

                if (mute) {
                    return null;
                }

                if (response && response.status === 400) {
                    return null;
                }
            }

            const hasPageLoadFailureMessage = isPageLoadFailureMessage(event?.message);
            if (hasPageLoadFailureMessage) {
                event.message = 'Loading chunk failed';
            }
            if (hasPageLoadFailureMessage || isPageLoadFailure(hint?.originalException)) {
                return markAsPageLoadFailure(event);
            }

            return event;
        },
        beforeBreadcrumb(breadcrumb, hint) {
            const { category, data = {} } = breadcrumb;
            if (category === 'xhr') {
                const { status_code: statusCode } = data;
                const { xhr: { response } = {} } = hint;
                if (statusCode === 400) {
                    data.response = response;
                }
            }

            return breadcrumb;
        },
        ...config,
    });
};

export default configureSentry;
